module.exports = __webpack_public_path__ + "img/B4.ff5ed690.png";